import api from './api';

export interface Municipio {
  id: string;
  nome: string;
  siglaEstado: string;
  comumMRN: boolean;
}

export const ListaEstados = [
  { text: 'AC', value: 'AC' },
  { text: 'AL', value: 'AL' },
  { text: 'AP', value: 'AP' },
  { text: 'AM', value: 'AM' },
  { text: 'BA', value: 'BA' },
  { text: 'CE', value: 'CE' },
  { text: 'DF', value: 'DF' },
  { text: 'ES', value: 'ES' },
  { text: 'GO', value: 'GO' },
  { text: 'MA', value: 'MA' },
  { text: 'MT', value: 'MT' },
  { text: 'MS', value: 'MS' },
  { text: 'MG', value: 'MG' },
  { text: 'PA', value: 'PA' },
  { text: 'PB', value: 'PB' },
  { text: 'PR', value: 'PR' },
  { text: 'PE', value: 'PE' },
  { text: 'PI', value: 'PI' },
  { text: 'RJ', value: 'RJ' },
  { text: 'RN', value: 'RN' },
  { text: 'RS', value: 'RS' },
  { text: 'RO', value: 'RO' },
  { text: 'RR', value: 'RR' },
  { text: 'SC', value: 'SC' },
  { text: 'SP', value: 'SP' },
  { text: 'SE', value: 'SE' },
  { text: 'TO', value: 'TO' },
];

export const getAllMunicipios = () => api.get<Municipio[]>('municipios');
export const getAllMunicipiosByMedicaoId = (medicaoId: string) =>
  api.get<Municipio[]>(`municipios/bymedicao/${medicaoId}`);
export const createMunicipio = (Municipio: Municipio) => {
  return api.post<any>('municipios', Municipio);
};
export const updateMunicipio = (Municipio: Municipio) => api.put<any>(`municipios/${Municipio.id}`, Municipio);
export const deleteMunicipio = (id: string) => api.delete(`municipios/${id}`);
export const getAllMunicipiosOptions = () =>
  getAllMunicipios().then(municipios =>
    (municipios || []).map(a => ({ text: a.nome, value: a.id.toString(), fav: a.comumMRN })),
  );
export const getAllMunicipiosOptionsByMedicaoId = (medicaoId: string) =>
  getAllMunicipiosByMedicaoId(medicaoId).then(municipios =>
    (municipios || []).map(a => ({ text: a.nome, value: a.id.toString(), fav: a.comumMRN })),
  );
